import React from 'react';
import { useAdminSecurity } from '@/hooks/useAdminSecurity';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { Clock, LogOut, Shield } from 'lucide-react';

const AdminSessionMonitor: React.FC = () => {
  const { 
    showTimeoutWarning, 
    extendSession, 
    forceLogout, 
    getTimeRemaining,
    isSessionValid 
  } = useAdminSecurity();
  const { language } = useLanguage();
  const isSpanish = language === 'es';

  if (!isSessionValid) return null;

  const formatTimeRemaining = (ms: number) => {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  if (showTimeoutWarning) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 p-4">
        <Alert variant="destructive" className="max-w-2xl mx-auto border-red-600 bg-red-50 dark:bg-red-950/90">
          <Shield className="h-4 w-4 text-red-600" />
          <AlertDescription>
            <div className="flex items-center justify-between">
              <div>
                <p className="font-semibold text-red-800 dark:text-red-200">
                  {isSpanish ? 'Sesión Expirando' : 'Session Expiring'}
                </p>
                <p className="text-red-700 dark:text-red-300">
                  {isSpanish 
                    ? `Tu sesión expirará en ${formatTimeRemaining(getTimeRemaining())}`
                    : `Your session will expire in ${formatTimeRemaining(getTimeRemaining())}`
                  }
                </p>
              </div>
              <div className="flex space-x-2">
                <Button 
                  onClick={extendSession}
                  size="sm"
                  className="bg-red-600 hover:bg-red-700 text-white"
                >
                  <Clock className="w-4 h-4 mr-1" />
                  {isSpanish ? 'Extender' : 'Extend'}
                </Button>
                <Button 
                  onClick={forceLogout}
                  size="sm"
                  variant="outline"
                  className="border-red-600 text-red-600 hover:bg-red-50 dark:hover:bg-red-950"
                >
                  <LogOut className="w-4 h-4 mr-1" />
                  {isSpanish ? 'Salir' : 'Logout'}
                </Button>
              </div>
            </div>
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return null;
};

export default AdminSessionMonitor;